import script from "./Header.vue?vue&type=script&lang=ts&setup=true"
export * from "./Header.vue?vue&type=script&lang=ts&setup=true"

import "./Header.vue?vue&type=style&index=0&id=5aba301a&scoped=true&lang=scss"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5aba301a"]])

export default __exports__